
import React from 'react';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from '@mui/material/Divider';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import { useHistory } from "react-router-dom";
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShareSquare } from '@fortawesome/free-solid-svg-icons';
import { RWebShare } from "react-web-share";

const MySpotList = ({ spots }) => {

  const history = useHistory();
  
  const routeChange = (spotId) =>{ 
    let path = `spotdetail/`+spotId; 

    history.push(path);
  }

  return (
    <div >
      {spots.map(selected => (
      <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
      <ListItem alignItems="flex-start" button onClick={() => routeChange(selected.spotId)}>
      <ListItemAvatar>
        <Avatar
            style={{ backgroundColor: selected.score, fontSize: 20 }} 
            size={30}>{selected.waveHeight}<span style={{ color: "white", fontSize: 13 }}>ft</span>
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={selected.spotName}
        secondary={"Wave Heigh:"+ selected.waveHeight + "ft - Period: " + selected.wavePeriod + "s" + " - Direction: " + selected.compassDirection}
      />
      <RWebShare
                    data={{
                        text: "Check it out! " + selected.spotName + " - " + selected.waveHeight + "ft",
                        url: "https://surf-spots-ui.vercel.app",
                        title: "Surf Alert!",
                    }}>
                    <Link>
                  <FontAwesomeIcon size="lg" icon={faShareSquare} className="highlight" />
                  </Link>
                </RWebShare>
      </ListItem>
      <Divider variant="inset" component="li" />
      </List>
      ))}
      
    </div>
  );
};

export default MySpotList